import React, { useContext, useEffect, useMemo, useState } from 'react';
import { IntegrationMetadata, MerchantIntegration } from '@anticatrade/shared';
import { AppContext, appContext } from '../../../context/AppContext';

const useMerchantIntegrations = () => {
	const [merchantIntegrations, setMerchantIntegrations] = useState<MerchantIntegration[]>([]);
	const [isLoadingIntegrations, setIsLoadingIntegrations] = useState<boolean>(true);

	const { api, merchant } = useContext(appContext as React.Context<AppContext>);

	const hasIntegrations = merchant?.features?.includes('integrations') ?? false;

	useEffect(() => {
		if (!hasIntegrations) {
			setIsLoadingIntegrations(false);
			return;
		}
		const load = async () => {
			try {
				const { integrations } = await api.merchantIntegrations();
				setMerchantIntegrations(integrations);
			} catch {
				// Non-critical: the publish dialog falls back to its
				// empty state and the logos are simply not shown.
			} finally {
				setIsLoadingIntegrations(false);
			}
		};
		load();
	}, [hasIntegrations]);

	const integrationByKey = useMemo(() => {
		const map = new Map<string, IntegrationMetadata>();
		for (const mi of merchantIntegrations) {
			if (mi.metadata != null) {
				map.set(mi.integrationKey, mi.metadata);
			}
		}
		return map;
	}, [merchantIntegrations]);

	return { isLoadingIntegrations, merchantIntegrations, integrationByKey };
};

export { useMerchantIntegrations };
